<gl-base-modal (closeModal)="close()">
  <h2 class="title">{{ 'import_file' | translate }}</h2>
  <!--  OLD IMPORT INFO-->
  <!--  <p class="info">-->
  <!--    <a normal-link [href]="getInstructionLink()" target="_blank">{{-->
  <!--        'import_file_message_link_1' | translate-->
<!--      }}</a>-->
<!--    {{ 'import_file_message' | translate }}-->
<!--    <a normal-link (click)="downloadCsvTemplate()">{{-->
<!--        'import_file_message_link_2' | translate-->
<!--      }}</a>-->
<!--    {{ 'or' | translate }}-->
<!--    <a normal-link (click)="downloadXlsxTemplate()">{{-->
<!--        'import_file_message_link_3' | translate-->
<!--      }}</a>-->
<!--  </p>-->
<div class="info">
  <p class="infoP">
    <a normal-link [href]="getInstructionLink()" target="_blank">{{
      'see_instruction' | translate
    }}</a>
  {{ 'instruction_message' | translate }}:</p>
  <table class="templatesTable">
    <thead>
      <th>{{ 'CSV_file' | translate }}</th>
      <th>{{ 'XLSX_file' | translate }}</th>
    </thead>
    <tbody>
      <tr>
        <td><a normal-link (click)="downloadTemplate('vehicle', true)">{{
          'Vehicle' | translate
        }}</a></td>
        <td><a normal-link (click)="downloadTemplate('vehicle')">{{
          'Vehicle' | translate
        }}</a></td>
      </tr>
      <tr>
        <td><a normal-link (click)="downloadTemplate('sea', true)">{{
          'Marine_container' | translate
        }}</a></td>
        <td><a normal-link (click)="downloadTemplate('sea')">{{
          'Marine_container' | translate
        }}</a></td>
      </tr>
      <tr>
        <td><a normal-link (click)="downloadTemplate('air', true)">{{
          'Air_container' | translate
        }}</a></td>
        <td><a normal-link (click)="downloadTemplate('air')">{{
          'Air_container' | translate
        }}</a></td>
      </tr>
      <tr>
        <td><a normal-link (click)="downloadTemplate('multistops', true)">{{
          'Multistops' | translate
        }}</a></td>
        <td><a normal-link (click)="downloadTemplate('multistops')">{{
          'Multistops' | translate
        }}</a></td>
      </tr>
    </tbody>
  </table>
</div>
@for (error of errorsList$ | async; track error) {
  <p class="error" [innerHTML]="error">
  </p>
}
@if (errorTranslationName) {
  <p class="error">
    {{ errorTranslationName | translate }}: {{ errorTranslationMessage | translate }}
  </p>
}
<form [formGroup]="form">
  <p class="checkbox">
    <gl-checkbox formControlName="saveLoadsAndLoading">
      {{ 'save_load_loading' | translate }}
    </gl-checkbox>
  </p>
</form>
<div class="buttons">
  <button normal-outline-button type="button" onclick="upload1.click()">
    {{ 'import' | translate }}
  </button>
  <input
    id="upload1"
    type="file"
    class="input-file"
    (change)="handleFiles(getFile($event))"
    #fileInput
    />
</div>
</gl-base-modal>
